import Profile from './Profile';

const Request = {
  Profile,
};

export default Request;
